import { useState } from 'react';
import { Card, Tabs } from 'antd';
import { ScissorOutlined, TableOutlined } from '@ant-design/icons';
import { ErpMasterShell } from '../../../../components/common/erp-grid';
import useAuth from '../../../../hooks/useAuth';
import CuttingPlannerTab from './CuttingPlannerTab';
import PlanTrackerTab from './PlanTrackerTab';
import { hasPermission, PERM } from './cuttingPlannerHelpers';

// ════════════════════════════════════════════════════════════════════
// Glass-i — Stage PRODUCTION-CUTTING-PLANNER-1 · Cutting Planner page.
// Two tabs: build OPT / cutting plans from open work-order pieces, then track
// completion (from real scan logs) + export a CNC XLS. No nesting/optimization.
// ════════════════════════════════════════════════════════════════════

export default function ProductionPlanning() {
  const { me } = useAuth();
  const [tab, setTab] = useState('planner');
  const [editTarget, setEditTarget] = useState(null);
  const [trackerRefresh, setTrackerRefresh] = useState(0);

  const readOnly = !hasPermission(me, PERM.MANAGE);

  return (
    <ErpMasterShell>
      <Card size="small" styles={{ body: { padding: 12 } }}>
        <Tabs
          activeKey={tab}
          onChange={setTab}
          tabBarExtraContent={readOnly ? <span className="text-[12px] text-slate-400">Read-only</span> : null}
          items={[
            {
              key: 'planner',
              label: <span className="flex items-center gap-1.5"><ScissorOutlined /> Cutting Planner</span>,
              children: (
                <CuttingPlannerTab
                  me={me}
                  editTarget={editTarget}
                  onSaved={() => { setEditTarget(null); setTrackerRefresh((n) => n + 1); setTab('tracker'); }}
                />
              )
            },
            {
              key: 'tracker',
              label: <span className="flex items-center gap-1.5"><TableOutlined /> Plan Tracker</span>,
              children: (
                <PlanTrackerTab
                  me={me}
                  refreshKey={trackerRefresh}
                  onEdit={(planId) => { setEditTarget({ planId, ts: Date.now() }); setTab('planner'); }}
                />
              )
            }
          ]}
        />
      </Card>
    </ErpMasterShell>
  );
}
